import { render, staticRenderFns } from "./SaleShow.vue?vue&type=template&id=04f9cf42&scoped=true&"
import script from "./SaleShow.vue?vue&type=script&lang=js&"
export * from "./SaleShow.vue?vue&type=script&lang=js&"
import style0 from "./SaleShow.vue?vue&type=style&index=0&id=04f9cf42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f9cf42",
  null
  
)

export default component.exports